export function sumEnteredPrincipal(rows) {
  let hasEnteredPrincipal = false;
  let total = 0;

  for (const row of Array.isArray(rows) ? rows : []) {
    if (row?.principal === "" || row?.principal == null) continue;

    const principal = Number(row.principal);
    if (!Number.isFinite(principal)) continue;

    hasEnteredPrincipal = true;
    total += principal;
  }

  return hasEnteredPrincipal ? total : null;
}
